import { render, staticRenderFns } from "./SelectCampaignsTableTab.vue?vue&type=template&id=4271971e"
import script from "./SelectCampaignsTableTab.vue?vue&type=script&lang=js"
export * from "./SelectCampaignsTableTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports